import Container from '@/components/layout/Container';
import ExternalLink from '@/components/elements/ExternalLink';

export default function HTMLSitemap({ block, position }) {
  const { section, title, _metadata } = block?.html_sitemap ?? {};
  const uid = _metadata?.uid ?? 'html-sitemap';

  return (
    <section
      id={`${uid}_${position}`}
      data-name="html-sitemap"
      className="html_sitemap pt-15 pb-20"
    >
      <Container fullPage={false} className="px-4">
        {title && (
          <h1 className="h3 sm:h2 lg:h1 flex w-full justify-center pb-15">
            {title}
          </h1>
        )}
        <div className="grid-row-2 sm:grid-row-1 grid grid-cols-2 gap-x-8 gap-y-20 px-1 sm:px-5 lg:grid-cols-3 lg:px-0">
          {section?.map(({ section_title, item }, sectionIndex) => (
            <div key={sectionIndex}>
              <h2
                id={section_title}
                className="sh10 sm:sh9 mb-3"
                aria-labelledby={section_title}
              >
                {section_title}
              </h2>
              {item?.length > 0 && (
                <ul className="mt-4">
                  {item.map(({ reference, item_title }, itemIndex) => (
                    <li key={itemIndex} className="pt-3">
                      <ExternalLink
                        linkStyling="hover:text-cozy-cognac text-black underline body-r"
                        internalLink={reference[0]?.url}
                        linkText={item_title}
                      />
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
}
